export default __webpack_public_path__ + "static/media/kweak_xl.1bbeacc8.jpg";